import React, { useState, useEffect, useRef } from "react";
import { Link } from "gatsby";
import { InView } from 'react-intersection-observer';
import HeaderAnim from "../utils/animations/textRevealAnimation";
import { SlideInWithScroll, animationTypes } from '../utils/animations/slideInWithScroll';
import { motion } from "framer-motion";
import Parallax from "../utils/animations/parallax";
import { directions } from "../utils/animations/animationConstants";
import LazyLoad from 'react-lazyload';

function GridLayoutStrategy(props) {
  const { gridItems, classes, link, title, header, content } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const ref = useRef();

  const setValues = () => {
    if (!ref.current) return;

    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    setValues();
    document.addEventListener('load', setValues);
    window.addEventListener('resize', setValues);
    return () => {
      document.removeEventListener('load', setValues);
      window.removeEventListener('resize', setValues);
    };
  }, [ref]);

  const triggers = [[1, 0.85], [0.9, 0.75], [0.8, 0.65]];
  return (
    <InView onChange={(inView) => setIsVisible(inView)} threshold={[0.3]} onLoad={setValues} id={props.id}>
      <div ref={ref} className="service-landing-intro section-gap" id='service-landing-intro'>
        <div className={`section-gap-small ${classes}`}>
          <div className="container">
            <p className="theme-color-title" >{isVisible && <HeaderAnim header={title} />}</p>
            <h2 className="h3">{header}</h2>
            {/*{content}*/}
          </div>
        </div>
        <div className="two-column-layout-section digital-strategy">
          <div className="container">
            <div className="row d-flex flex-wrap justify-center">
              {gridItems && gridItems.map((item, i) => {
                return <Parallax classes="col two-column-item" key={i} id={"two-column-item" + i} direction={directions.LTR} length={100} opacity={true} triggers={triggers[i]}>
                  <div className="item-inner">
                    <div className="item-icon">
                      <i className="icon-small"><LazyLoad><img src={item.image} title={item.title} alt={item.alt} /></LazyLoad></i>
                    </div>
                    <div className="item-content">
                      <h3 className="h5">{item.header}</h3>
                      <p>{item.content}</p>
                    </div>
                  </div>
                </Parallax>;
                //return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} triggerPoints={[triggerPoints[i], triggerPoints[i + 2]]} children={jsx} type={animationTypes.HORIZONTAL} key={i} />;
              })}
            </div>
            <Parallax classes="text-center" id="service-landing-into-btn" direction={directions.LTR} length={50} triggers={[1, 0.8]} opacity={true}>
              <Link className="button button-black right-arrow" to={link} >Learn More</Link>
            </Parallax>
          </div>
        </div>
      </div>
    </InView>
  );
};

export default GridLayoutStrategy;